import styled from 'styled-components';
import Spring from '../../components/Spring';

export const Container = styled(Spring)`
    overflow: hidden;
    background-color: ${p => p.theme.c.snow};

    > div {
        max-width: 320px;
        margin: auto;
        margin-top: 64px;
        margin-bottom: 32px;
    }
    min-height: calc(100vh - 50px);

`;